import { Constant, Name, Option, Zone } from 'types';
import { CustomerData } from 'types/api/customer.type';

export const mapConstantIntoOptions = (data: Constant[], asRanking?: boolean) =>
  data.map((item: Constant) => ({
    value: item.key,
    label: asRanking ? `${item.value} stars` : item.value,
  }));

export const mapNameIntoOptions = (data: Name[]): Option[] =>
  data.slice(4).map(
    (item: Name): Option => ({
      value: item.id,
      label: item.name,
    })
  );

export const mapZonesIntoOptions = (data: Zone[]): Option[] =>
  data.map(
    (item: Zone): Option => ({
      value: item.code,
      label: item.code,
    })
  );

export const mapCustomerIntoOptions = (data: CustomerData[]): Option[] =>
  data?.map((item) => ({
    value: item.code,
    label: `${item.code} - ${item.companyName}`,
  }));
